import moment from "moment"

function getCurrentRecurrenceLogEntry(userAction) {
 
  // First Created - 03 Sep 2025
  // Author - Atul Pandey
  // Purpose - to find actions logs to update for a recurring user action
  // Updated - 30 Dec 2025 - Fix - Timewindow and userTimeZone for recurrence zones - non Daily
  // Updated - 05 Jan 2026 - Fix - moment startOf fix

  // const now = moment().startOf("day");                           // 30 Dec 2025 - commented out
  // const now = moment().tz(userAction?.userTimeZone).startOf("day");  // 30 Dec 2025, 05 Jan 2026 - commented out

  // 05 Jan 2026
  const tz = userAction?.userTimeZone || moment.tz.guess() || "UTC";
  const now = moment().tz(tz).startOf("day");

  if (!userAction?.recurringActionLog || !Array.isArray(userAction?.recurringActionLog)) return null;

  for (const log of userAction?.recurringActionLog) {
    // const logDate = moment(log.logDate).startOf("day");                              // 30 Dec 2025 - commented out
    const logDate = moment.utc(log.logDate)
                    .tz(tz) // 05 Jan 2026
                    // .tz(userAction?.userTimeZone)
                    .startOf("day"); // 30 Dec 2025
    const pattern = log?.logPatternSnapshot || userAction?.actionRecurrencePattern;

    // let start = logDate.clone(); // 30 Dec 2025
    let start; // 30 Dec 2025
    let end;

    switch (pattern) {
      case "Daily":
        // end = start.clone();                   // 30 Dec 2025 - commented out
        start = logDate.clone();                  // 30 Dec 2025
        end   = logDate.clone();                  // 30 Dec 2025
        break;
      case "Weekly":
        // end = start.clone().add(6, "days");    // 30 Dec 2025 - commented out
        start = logDate.clone();                  // 30 Dec 2025
        end   = logDate.clone().add(6, "days");   // 30 Dec 2025
        break;
      case "BiWeekly":
        // end = start.clone().add(13, "days");   // 30 Dec 2025 - commented out
        start = logDate.clone();                  // 30 Dec 2025
        end   = logDate.clone().add(13, "days");  // 30 Dec 2025
        break;
      case "Monthly":
        // end = start.clone().endOf("month");      // 30 Dec 2025 - commented out
        start = logDate.clone().startOf("month");   // 30 Dec 2025  
        end   = logDate.clone().endOf("month");     // 30 Dec 2025
        break;
      case "Quarterly":
        // end = start.clone().add(2, "months").endOf("month"); // 30 Dec 2025 - commented out
        start = logDate.clone().startOf("quarter");             // 30 Dec 2025
        end   = logDate.clone().endOf("quarter");               // 30 Dec 2025 
        break;
      case "SemiAnnually":
        // end = start.clone().add(5, "months").endOf("month"); // 30 Dec 2025 - commented out
        start = logDate.clone().month() < 6                     // 30 Dec 2025  
           ? logDate.clone().month(0).startOf("month")
           : logDate.clone().month(6).startOf("month");
        end = start.clone().add(5, "months").endOf("month");    // 30 Dec 2025
        break;
      case "Annually":
        // end = start.clone().add(11, "months").endOf("month");  // 30 Dec 2025 - commented out
        start = logDate.clone().startOf("year");                  // 30 Dec 2025
        end   = logDate.clone().endOf("year");                    // 30 Dec 2025
        break;
      default:
        // end = start.clone();                                   // 30 Dec 2025 - commented out
        start = logDate.clone();                                  // 30 Dec 2025
        end   = logDate.clone();                                  // 30 Dec 2025
    }

    if (now.isSameOrAfter(start) && now.isSameOrBefore(end)) {
      return log; // ✅ Active log window
    }
  }

  return null; // 🚫 No current log window found
}

function getNextRecurrenceLogDate(userAction) {
  // First Created: 27 Sep 2025
  // Author: Atul Pandey
  // Purpose: Get the next scheduled log date for a recurring user action
  // Updated - 30 Dec 2025 - Fix - Timewindow and userTimeZone for recurrence zones - non Daily

  // const now = moment().startOf("day");                           // 30 Dec 2025 - commented out
  // const now = moment().tz(userAction.userTimeZone).startOf("day");  // 30 Dec 2025, 05 Jan 2026 - commented out

  // 05 Jan 2026
  const tz = userAction?.userTimeZone || moment.tz.guess() || "UTC";
  const now = moment().tz(tz).startOf("day");

  if (!userAction?.recurringActionLog || !Array.isArray(userAction.recurringActionLog)) return null;

  const futureLogs = userAction.recurringActionLog
    // .filter((log) => moment(log.logDate).isAfter(now)) // 30 Dec 2025 - commented out
    .filter((log) =>                                      // 30 Dec 2025
        moment.utc(log.logDate)
          .tz(tz) // 05 Jan 2026
          // .tz(userAction?.userTimeZone)
          .isAfter(now)
    )
    .sort((a, b) => new Date(a.logDate) - new Date(b.logDate));

  return futureLogs.length > 0 ? futureLogs[0].logDate : null;
}

export { 
    getCurrentRecurrenceLogEntry,
    getNextRecurrenceLogDate,
}
